const styles = theme => ({
  root: {
    padding: "8px 10px",
    verticalAlign: "middle",
    height: "100%",
    color: theme.gridIconBorderColor,
    "&$checked": {
      color: theme.HeaderSelectedText
    }
  },
  checked: {
    color: theme.HeaderSelectedText
  },
  container: {
    padding: "40px 5px 0px 5px"
  },
  formLabel: {
    padding: "5px 0px",
    fontWeight: "bold",
    color: theme.gridIconBorderColor,
    margin: 0
  },
  label: {
    color: theme.gridTextColor
  },
  data: {
    fontSize: "32px",
    color: theme.ColumnHeaderTextColor,
    margin: 0
  },
  cardContent: {
    padding: "5px",
    color: theme.gridTextColor,
    fontSize: "14px"
  },
  card: {
    borderLeft: `4px solid ${theme.gridIconBorderColor}`,
    background: theme.ModalBGColor,
    width: "75%",
    margin: "auto"
  },
  Dropdown: {
    backgroundColor: theme.ModalBGColor,
    color: theme.TextColor
  },
  reactSelect: {
    "& .select__control": {
      backgroundColor: "transparent",
      fontSize: 12,
      cursor: "pointer",
      "&:hover,&.select__control--is-focused": {
        boxShadow: "none",
        border: `1px solid ${theme.iconColor}`
      },
      "& .select__value-container": {
        color: theme.TextColor,
        padding: "0px 8px",
        "& .select__input": {
          color: theme.TextColor
        },
        "&>div": {
          margin: 0
        },
        "&>.select__multi-value": {
          margin: 2,
          backgroundColor: theme.HeaderSelectedText,
          "&>div": {
            color: "white",
            padding: 4
          },
          "& .select__multi-value__remove": {
            padding: "4px 0",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: theme.HeaderSelectedText
            }
          }
        }
      },
      "& .select__single-value": {
        color: "inherit"
      },
      "& .select__indicators": {
        "& .select__indicator": {
          padding: 5
        },
        "& .select__indicator-separator": {
          margin: 0,
          display: "none"
        }
      }
    },
    "& .select__menu": {
      margin: 0,
      maxHeight: 140,
      borderRadius: 2,
      border: `1px solid ${theme.iconColor}`,
      "& .select__menu-list": {
        maxHeight: 138,
        borderRadius: 2,
        fontSize: 12,
        backgroundColor: theme.ModalBGColor,
        color: theme.TextColor
      },
      "& .select__option--is-focused": {
        backgroundColor: theme.HighlightColor,
        cursor: "pointer"
      },
      "& .select__option--is-selected": {
        backgroundColor: theme.HeaderSelectedText
      }
    }
  },

  iconStyle: {
    color: theme.iconColor,
    cursor: "pointer"
  },

  multiValueApplied: {
    "& .select__control": {
      borderBottom: `1px solid ${theme.HeaderSelectedText}`,
      "&:hover,&.select__control--is-focused": {
        borderBottom: `1px solid ${theme.HeaderSelectedText}`
      }
    }
  },
  warningNote: {
    color: theme.gridIconBorderColor,
    fontSize: "12px",
    fontWeight:"bold"
  },
  datePickerInput:{
    width:"100%",
    padding:"5px"
  },
  inputRoot:{
    fontSize: "16px",
    fontWeight: "bold",
    cursor:"pointer",
    color: theme.gridIconBorderColor,
    '&:hover, &::before, &::after':{
      border: "none !important"
  }
  }
});

export default styles;
